<script setup lang="ts">
import OKCancelModal from "../../components/OKCancelModal.vue";

interface QuantityIncreaseReductionSummary {
  poSequence: number;
  currentQty: number;
  newQty: number;
}

const props = defineProps<{
  sku: string;
  targetPoSequence: number;
  newQty: number;
  fromLeftover: number;
  reductions: QuantityIncreaseReductionSummary[];
  onConfirm: () => void;
  onCancel?: () => void;
}>();

function handleOk(): void {
  props.onConfirm();
}

function handleCancel(): void {
  props.onCancel?.();
}
</script>

<template>
  <OKCancelModal
    title="Confirm quantity increase"
    ok-button-text="Apply increase"
    cancel-button-text="Cancel"
    :on-ok="handleOk"
    :on-cancel="handleCancel"
  >
    <p class="qty-increase-modal-summary">
      Increasing SKU {{ sku }} on PO {{ targetPoSequence }} to {{ newQty }}
      needs
      <strong v-if="fromLeftover > 0"
        >{{ fromLeftover }} unit{{ fromLeftover === 1 ? "" : "s" }} from
        leftover inventory</strong
      ><span v-if="fromLeftover > 0 && reductions.length > 0"> and </span
      ><strong v-if="reductions.length > 0"
        >units taken from other suggested POs</strong
      >.
    </p>
    <ul v-if="reductions.length > 0" class="qty-increase-modal-list">
      <li v-for="reduction in reductions" :key="reduction.poSequence">
        PO {{ reduction.poSequence }}: {{ reduction.currentQty }} →
        {{ reduction.newQty }}
      </li>
    </ul>
  </OKCancelModal>
</template>

<style scoped>
.qty-increase-modal-summary {
  margin: 0 0 0.75rem;
  color: var(--text-primary, #172033);
  font-size: 0.85rem;
}

.qty-increase-modal-list {
  margin: 0;
  padding-left: 1.1rem;
  color: var(--text-secondary, #5d6878);
  font-size: 0.82rem;
}

.qty-increase-modal-list li + li {
  margin-top: 0.25rem;
}
</style>
